import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
	apiKey: 'AIzaSyCLAiunYoEFePHFK4mS1UniROC4wWzEaD8',
	authDomain: 'foodtwosteps-a45d6.firebaseapp.com',
	projectId: 'foodtwosteps-a45d6',
	storageBucket: 'foodtwosteps-a45d6.firebasestorage.app',
	messagingSenderId: '18756672867',
	appId: '1:18756672867:web:a449dd4a242520c57a0756',
	measurementId: 'G-BPQS0600L7',
}

export const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
